<template>
<div class="chapter">
<div class="inner_page">
<p class="copy1"><a id="page_iv"></a>Text copyright © 2014 by Stephanie Perry Moore</p>
<p class="copy2">All rights reserved. International copyright secured. No part of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopying, recording, or otherwise—without the prior written permission of Lerner Publishing Group, Inc., except for the inclusion of brief quotations in an acknowledged review.</p>
<p class="copy2">Darby Creek</p>
<p class="copy3">A division of Lerner Publishing Group, Inc.</p>
<p class="copy3">241 First Avenue North</p>
<p class="copy3">Minneapolis, MN 55401 USA</p>
<p class="copy2">For reading levels and more information, look up this title at <a href="http://www.lernerbooks.com" target="_blank">www.lernerbooks.com</a>.</p>
<p class="copy2">The images in this book are used with the permission of: Front cover: © Andreas Kuehn/Iconica/Getty Images: © SeanPavonePhoto/Shutterstock.com, (background).</p>
<p class="copy2">Main body text set in Janson Text LT Std 12/17.5.</p>
<p class="copy3">Typeface provided by Linotype AG.</p>
<p class="copy4">Library of Congress Cataloging-in-Publication Data</p>
<p class="copy2">Moore, Stephanie Perry.</p>
<p class="copy5">Icing on the cake / Stephanie Perry Moore.</p>
<p class="copy6">pages cm. — (The Sharp sisters; #5)</p>
<p class="copy7">Summary: Feeling like the untalented one in a family of five sisters, soon-to-be-sixteen-year-old Yuri, the adopted daughter of newly elected mayor Stanley Sharp, pursues her love of baking and grows in self-esteem when she takes a courageous stand.</p>
<p class="copy5">ISBN 978–1–4677–3728–9 (lib. bdg. : alk. paper)</p>
<p class="copy5">ISBN 978–1–4677–4656–4 (eBook)</p>
<p class="copy7">[1. Sisters—Fiction.  2. Self-esteem—Fiction.  3. Baking—Fiction.  4. Adoption—Fiction.  5. African Americans—Fiction.]  I. Title.</p>
<p class="copy8">PZ7.M788125Ic 2014</p>
<p class="copy8">[Fic]—dc23</p>
<p class="copy9">2014003172</p>
<p class="copy2">Manufactured in the United States of America</p>
<p class="copy3">1 – SB – 7/15/14<br/>eISBN: 978-1-46774-656-4 (pdf)<br/>eISBN: 978-1-46777-448-2 (ePub)<br/>eISBN: 978-1-46777-447-5 (mobi)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?687d18b3